import type { FaireProductEntity } from "../../entity_types/product";

export const p_rbyvfcr35h: FaireProductEntity = {
  token: "p_rbyvfcr35h",
  type: "product",
  name: "Lesley Elizabeth Rosemary & Basil Sea Salt (250mL PET)",
  brandToken: "b_wc2q3m3rxc",
  brandName: "Hongar Farms",
  imageUrl:
    "https://cdn.faire.com/fastly/622169d4502262c1823c1a8919b62eef952b2d4126e11fdeecb49990af37a4e8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0289ec98cadc73491cca235cbba68a9b71bd5c0acd2a405b5441b0bfc7067a78.png",
    "https://cdn.faire.com/fastly/d2344d007ca7d1e3c4abda9d4fe6eed9c7d8e376d7f2b2c3e2df30015ef5a866.png",
    "https://cdn.faire.com/fastly/519e705e57af88f31dd875fdf35336bb7f6932ae2d928ef8267e3742c7dfa762.png",
    "https://cdn.faire.com/fastly/108600350b9d7e00d57e28792439c65aee23cd5125356267e78583ffe463f486.png",
  ],
  priceDollars: 6.61,
  description:
    "Lesley Elizabeth’s Rosemary & Basil Sea Salt brings fresh, herbaceous flavor to everyday cooking. This aromatic blend of rosemary, basil, and sea salt adds a savory, garden-fresh touch to poultry, pork, vegetables, and more. Use it as a rub by drizzling with oil and seasoning generously, or substitute it for table salt to elevate soups, sauces, and marinades. Versatile and easy to use, this gourmet seasoned salt delivers rich, herb-forward taste in every sprinkle. Small-batch crafted and packed in a 250mL PET shaker, it’s a kitchen essential for cooks who love bold yet balanced flavor.",
  tags: [],
  msrpDollars: 13.22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:44.081Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
